@if(loader){
<app-loader></app-loader>
}

<p-card header="">
    <div class="">
        <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
            <div class="flex align-items-center">
                <div>
                    <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle"
                        (click)="createPaymentTerms()" size="small" pTooltip="Create Payment Term"></p-button>
                </div>
                <div class="flex align-items-center ml-3">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"
                            class=" p-inputtext-sm" (keyup.enter)="searchPayment()"
                            style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
                    </span>
                    <p-button icon="pi pi-search" (onClick)="searchPayment()" class="ml-2"
                        [ngStyle]="{ height: '35px' }" [raised]="true" [size]="'small'" severity="info"></p-button>
                </div>
                <p-button *ngIf="selectedPaymentTerms && selectedPaymentTerms.length == 1" label="Edit" class="ml-2"
                    icon="pi pi-pencil" (click)="editPaymentTerms()" size="small" severity="secondary"></p-button>
                <p-button *ngIf="selectedPaymentTerms && selectedPaymentTerms.length > 0" label="Delete" class="ml-2"
                    icon="pi pi-trash" (click)="deletePaymentTerms()" size="small" severity="danger"></p-button>
            </div>

            <h2 class="page-title-center">Payment Terms List</h2>

            <div class="flex">
                <div class="flex align-items-center">
                    <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true"
                        severity="info"></p-button>
                </div>
            </div>
        </div>


        <!--code added here-->
        <p-table #dt1 [value]="paymenttermsResult" [scrollable]="false" scrollHeight="650px" styleClass="p-datatable-sm"
            [totalRecords]="totalRecords" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm "
            [paginator]="true" [rows]="10"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            (onPage)="loadpayments($event)" [rowsPerPageOptions]="[10,15,20]" [rowHover]="true"
            [globalFilterFields]="['paymentTermsId','termsCode']" [(selection)]="selectedPaymentTerms">

            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Payment Terms Code</th>
                    <th>Discount</th>
                    <th>Conditional Discount (Days)</th>
                    <th>Net Due</th>
                    <th>Description</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-paymentTerms>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="paymentTerms"></p-tableCheckbox>
                    </td>
                    <td class="text-blue-500 underline" style="cursor: pointer;"
                        (click)="editPaymentTerms(paymentTerms.paymentTermsId)">{{paymentTerms.termsCode}}</td>
                    <td>{{paymentTerms.discount}}</td>
                    <td>{{paymentTerms.conditionalDiscount}}</td>
                    <td>{{paymentTerms.netDue}}</td>
                    <td>{{paymentTerms.paymentTermsDescription}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>